import React, { Component } from "react";
import { connect } from 'react-redux'
import moment from "moment";
import { isEmpty } from 'lodash'
// Components
import { Row, Col } from "antd";
import helper from '../../helper/helper';
import constant, { functionsCode } from '../../constants/constant'

import BieuDoCot from "../../components/Trangchu/BieuDoCot";
import Bieudocotmobile from "../../components/Trangchumobile/Bieudocotmobile";

import { Scrollbars } from 'react-custom-scrollbars';
import ThongKe from '../../components/Trangchu/ThongKe'
import ThongKeMB from '../../components/Trangchumobile/Thongkemobile'
import { APP_TNN_URI } from '../../config';
import Clock from 'react-live-clock';
import Api from "../../api";
import ScrollDown from '../../assets/images/ScrollDown.png'
import ScrollUp from '../../assets/images/ScrollUp32px.png'
let date = moment().locale("vi").format('L');
let day = moment().locale("vi").format('dddd');
class TrangChu extends Component {
  constructor(props) {
    super(props);
    const { functions } = props;
    this.state = {
      editable: !isEmpty(functions) ? helper.handleGetEditableFunction(functions, functionsCode.TRANG_CHU).editable : false,
      linkIcon: ""
    };
    this.handleClickTopPosition = this.handleClickTopPosition.bind(this);
    this.handleClickBottomPosition = this.handleClickBottomPosition.bind(this);
  }

  componentDidMount() {
    const { scrollbars } = this.refs;
    let ClientHeight = scrollbars.getClientHeight()
    let ScrollHeight = scrollbars.getScrollHeight()
    if (ScrollHeight > ClientHeight && ScrollHeight - ClientHeight > 100) {
      this.setState({ linkIcon: "end" })
    }
  }
  componentWillMount() {
    this.Profile()
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps !== this.props) {
      const { functions } = this.props;
      if (!isEmpty(functions)) {
        const func = helper.handleGetEditableFunction(functions, functionsCode.TRANG_CHU);
        this.setState({ editable: func.editable })
      }
    }
  }
  Profile = () => {
    const { user } = this.props;
    new Api().Profile({
      token: user.access_token,
    })
      .then(res => {
        if (res && res.roles && res.roles.length > 0) {
          if (res.roles[0].cap === 4) {
            window.location.href = APP_TNN_URI + "BCDN/TNN"
          }
        }
      })
      .catch(err => { })
  };

  handleClickTopPosition() {
    const { scrollbars } = this.refs;
    scrollbars.scrollTop();
    this.setState({ linkIcon: "end" })
  }
  handleClickBottomPosition() {
    const { scrollbars } = this.refs;
    scrollbars.scrollToBottom();
    this.setState({ linkIcon: "start" })
  }
  onScroll = () => {
    const { scrollbars } = this.refs;
    let ClientHeight = scrollbars.getClientHeight()
    let ScrollHeight = scrollbars.getScrollHeight()
    if (ScrollHeight > ClientHeight && ScrollHeight - ClientHeight > 100) {
      const scroll = scrollbars.getValues();
      if (scroll.top > 0.5) {
        this.setState({ linkIcon: "start" })
      } else if (scroll.top < 0.5) {
        this.setState({ linkIcon: "end" })
      }
    }
  }

  render() {
    return (
      <div className="Dashboard" style={{ overflow: "hidden" }}>
        {window.innerWidth < 500 ?
          <div>
            <Row style={{ background: "#ced2d83d" }}>
              <Col>
                <div style={{ margin: 10, height: 40, display: "flex", justifyContent: "space-between" }} className="linh-vuc-title">
                  <div style={{ color: "#3c4b79" }}>
                    TRANG CHỦ</div>
                  <div style={{ fontSize: "unset", color: "#3c4b79", textTransform: "capitalize", paddingLeft: "60px" }}>

                    {day.charAt(0).toUpperCase() + day.slice(1) + ", " + date.charAt(0).toUpperCase() + date.slice(1)},

                    <Clock interval={1000}
                      format={'h:mm:ss'}
                      timezone={'Asia/Ho_Chi_Minh'}
                      ticking={true} />
                  </div>

                </div>
              </Col>
            </Row>
            <Scrollbars ref="scrollbars" style={{ height: window.innerHeight - 130 }} autoHide autoHideTimeout={1000} autoHideDuration={200} onScrollStop={() => this.onScroll()}>
              <Row>
                <ThongKeMB
                  history={this.props.history}
                />
              </Row>
              <Row>
                <Bieudocotmobile history={this.props.history}>
                </Bieudocotmobile>
              </Row>
            </Scrollbars>
          </div>
          :
          <div>
            <Row style={{ background: "#ced2d83d" }}>
              <Col>
                <div style={{ margin: 10, height: 40, display: "flex", justifyContent: "space-between" }} className="linh-vuc-title">
                  <div style={{ paddingTop: 10, color: "#3c4b79" }}>
                    TRANG CHỦ</div>
                  <div style={{ fontSize: "unset", color: "#3c4b79", textTransform: "capitalize", paddingTop: 10, paddingRight: 30 }}>

                    {day.charAt(0).toUpperCase() + day.slice(1) + ", " + date.charAt(0).toUpperCase() + date.slice(1)},

                    <Clock interval={1000}
                      format={'h:mm:ss'}
                      timezone={'Asia/Ho_Chi_Minh'}
                      ticking={true} />
                  </div>

                </div>
              </Col>
            </Row>
            <Scrollbars ref="scrollbars" style={{ height: window.innerHeight - 130 }} autoHide autoHideTimeout={1000} autoHideDuration={200} onScrollStop={() => this.onScroll()}>
              <Row>
                <ThongKe
                  history={this.props.history}
                />
              </Row>
              <Row>
                <BieuDoCot history={this.props.history}>
                </BieuDoCot>
              </Row>
            </Scrollbars>
          </div>
        }
        {this.state.linkIcon === "end" &&
          <div style={{ position: "fixed", bottom: "60px", right: "50px" }}>
            <div onClick={this.handleClickBottomPosition} >
              <img className='css' src={ScrollDown} />
            </div>
          </div>}
        {this.state.linkIcon === "start" &&
          <div style={{ position: "fixed", bottom: "60px", right: "50px" }}>
            <div onClick={this.handleClickTopPosition} >
              <img className='css' src={ScrollUp} />
            </div>
          </div>}

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.oidc.user,
});

export default connect(mapStateToProps)(TrangChu);
